module.exports = __webpack_public_path__ + "files/b570a3ed3711134624ba9e1b4a62e64b.png";